import { render, staticRenderFns } from "./LegalAssetReport.vue?vue&type=template&id=3e86efda&"
import script from "./LegalAssetReport.vue?vue&type=script&lang=js&"
export * from "./LegalAssetReport.vue?vue&type=script&lang=js&"
import style0 from "./LegalAssetReport.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports